import { SharedModule } from 'src/app/shared/shared.module';
import { FaixaCarteiraPessoaJuridicaModule } from './features/distribuicao-limites-agentes/faixa-carteira-pessoa-juridica/faixa-carteira-pessoa-juridica.module';
import { CnaeImpedidoModule } from './features/cnae-impedido/cnae-impedido.module';
import { IrregularidadeEmpresaModule } from './features/irregularidade_empresa/irregularidade_empresa.module';
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { BnChannelsModule, BnHttpModule } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FilterPipeModule } from 'ngx-filter-pipe';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CustomReuseStrategy } from './custom-reuse-strategy';
import { AdministracaoModule } from './features/administracao/administracao.module';
import { AvisoModule } from './features/aviso/aviso.module';
import { EmpresasBloqueadasModule } from './features/empresas-bloqueadas/empresas-bloqueadas.module';
import { CobrancaModule } from './features/cobranca/cobranca.module';
import { ExportacaoModule } from './features/exportacao/exportacao.module';
import { DevolucaoHonraModule } from './features/contratacao/devolucao/devolucao-honra.module';
// Operacao
import { OperacaoModule } from './features/contratacao/operacao/operacao.module';
import { EscolhaModalidadeComponent } from './features/escolha-modalidade/escolha-modalidade.component';
// Inicio
import { HomeComponent } from './features/home/home.component';
import { SolicitacaoHonraModule } from './features/honra/solicitacao-honra/solicitacao-honra.module';
import { ValidacaoScrModule } from './features/honra/validacao-scr/validacao-scr.module';
import { ConsultaIpocModule } from './features/honra/consulta-ipoc/consulta-ipoc.module';
import { StoplossModule } from './features/honra/stoploss/stoploss.module';
import { InadimplenciaModule } from './features/inadimplencia/inadimplencia.module';
import { IntegracaoModule } from './features/integracao/integracao.module';
import { IrregularidadeModule } from './features/irregularidade_operacao/irregularidade.module';
import { NotasModule } from './features/notas/notas.module';
import { PrestacaoInformacoesModule } from './features/prestacao-informacoes/prestacao-informacoes.module';
import { TarefasModule } from './features/tarefas/tarefas.module';
import { RecuperacaoCreditoModule } from './features/recuperacao/recuperacao-credito/recuperacao-credito.module';
import { httpInterceptorProviders } from './interceptors';
import { EscolhaModalidadeGuard } from './interceptors/escolha-modalidade.guard';
import { PipesModule } from './pipes/pipes.module';
import { JanelasAtualizacaoInformacoesModule } from './features/janelas-atualizacao-informacoes/janelas-atualizacao-informacoes.module'
import { QuestionarioModule } from './questionario-fgenergia/questionario.module';
import { ValidacaoRecaptchaComponent } from './shared/recaptcha/validacao-recaptcha.component';
import { LoginModule } from './login/login.module';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { ModalidadeGarantiaModule } from './features/modalidade_garantia/modalidade-garantia.module';
import { TranchesModule } from './features/tranches/tranches.module';
import { ProgramasPermitidosPorCestasListagemComponent } from './features/programas-permitidos-por-cestas/listagem/programas-permitidos-por-cestas-listagem.component';
import { ProgramasPermitidosPorCestasModule } from './features/programas-permitidos-por-cestas/programas-permitidos-por-cestas.module';
import { NaturezasJuridicasAceitasModule } from './features/naturezas-juridicas-aceitas/naturezas-juridicas-aceitas.module';
import { SolicitacaoArquivosModule } from './features/solicitacao-arquivos/solicitacao-arquivos.module';
import { QuestionarioFgenergiaModule } from './features/contratacao/questionario-fgenergia/questionario-fgenergia.module';
import { LimiteHistoricoModule } from './features/contratacao/limite/limite-historico/limite-historico.module';
import { DistribuicaoLimitesModule } from './features/distribuicao-limites-agentes/distribuicao-limites.module';
import { AcompanhamentoBatchModule } from './features/honra/acompanhemento-de-rotinas-batch/acompanhamento-batch.module';
import { HabilitacaoModule } from './features/habilitacao/habilitacao.module'
import { PessoasJuridicasModule } from './features/pessoas-juridicas/pessoas-juridicas.module';
import { TaxasJurosModule } from './features/taxas-juros/taxas-juros.module';
import { CnaePermitidoModule } from './features/cnaes-permitidos-grandes-empresas/cnae-permitido.module';
import { RenunciaModule } from './features/renuncia/renuncia.module';
import { PorteBeneficiarioModule } from './features/porte-beneficiario/porte-beneficiario.module';
import { IndexadoresModule } from './features/indexadores/indexadores.module';
import { RecaptchaModule } from 'ng-recaptcha';
import { LeilaoModule } from './features/leilao/leilao-module.module';
import {ProdutosPermitidosModule} from './features/produtos-permitidos/produtos-permitidos.module';
import { ExportacaoAgenteFinanceiroModule } from './features/exportacao-agente-financeiro/exportacao-agente-financeiro.module';
import {ModalidadeScrModule} from './features/modalidade-scr/modalidade-scr.module';
import { LimitePagamentoEcgPorTerceirosModule } from './features/limite-pagamento-ecg-por-terceiros/limite-pagamento-ecg-por-terceiros.module';
import {EcgPorTerceirosModule} from './features/ecg-por-terceiros/ecg-por-terceiros.module';
import {ParametrizacaoModule} from "./features/parametrizacao/parametrizacao.module";
import { LimiteAdicionalModule } from './features/limite-adicional/limite-adicional.module';
import { RenunciaLimiteAdicionalModule } from './features/renuncia/renuncia-limite-adicional/renuncia-limite-adicional.module';

registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [AppComponent, HomeComponent, EscolhaModalidadeComponent, ValidacaoRecaptchaComponent],
  imports: [
    HttpClientModule,
    PipesModule,
    BrowserModule,
    CommonModule,
    OperacaoModule,
    AvisoModule,
    QuestionarioModule,
    InadimplenciaModule,
    ModalidadeGarantiaModule,
    TranchesModule,
    NotasModule,
    QuestionarioFgenergiaModule,
    LimiteHistoricoModule,
    DevolucaoHonraModule,
    NaturezasJuridicasAceitasModule,
    IrregularidadeModule,
    IrregularidadeEmpresaModule,
    ProgramasPermitidosPorCestasModule,
    CnaeImpedidoModule,
    SolicitacaoArquivosModule,
    ParametrizacaoModule,
    FaixaCarteiraPessoaJuridicaModule,
    DistribuicaoLimitesModule,
    CobrancaModule,
    ExportacaoModule,
    ExportacaoAgenteFinanceiroModule,
    SharedModule,
    SolicitacaoHonraModule,
    AcompanhamentoBatchModule,
    ConsultaIpocModule,
    ValidacaoScrModule,
    RecuperacaoCreditoModule,
    PrestacaoInformacoesModule,
    StoplossModule,
    AdministracaoModule,
    IntegracaoModule,
    CoreModule,
    BnChannelsModule.forRoot(),
    BnHttpModule.forRoot({ useCache: true, useDateInterceptor: false }),
    BrowserAnimationsModule,
    FilterPipeModule,
    JanelasAtualizacaoInformacoesModule,
    TarefasModule,
    LoginModule,
    RecaptchaModule,
    HabilitacaoModule,
    PessoasJuridicasModule,
    TaxasJurosModule,
    CnaePermitidoModule,
    RenunciaModule,
    RenunciaLimiteAdicionalModule,
    EmpresasBloqueadasModule,
    PorteBeneficiarioModule,
    IndexadoresModule,
    LeilaoModule,
    ProdutosPermitidosModule,
    ModalidadeScrModule,
    LimitePagamentoEcgPorTerceirosModule,
    EcgPorTerceirosModule,
    LimiteAdicionalModule,

    // precisa ser o ultimo
    AppRoutingModule,

  ],
  providers: [{ provide: LOCALE_ID, useValue: 'pt' },
              { provide: LocationStrategy, useClass: HashLocationStrategy },
              { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
              httpInterceptorProviders, EscolhaModalidadeGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
